import { DeliveryIcon, InvoiceIcon } from '@synergy/theme';
import { Divider, Theme, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { UsageType } from '@synergy/models';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    divider: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),

        height: 24,
        backgroundColor: theme.general.colors.black,
        alignSelf: 'center',
    },
    icons: {
        display: 'block',
        margin: 'auto',
        fontSize: 20,
    },
}));

interface GetUsageTypeIconProps {
    usageType?: UsageType;
}

const DeliveryAddress = () => {
    const classes = useStyles();

    return (
        <Tooltip title={<FormattedMessage id="app.table.column.deliveryAddress" />} placement="bottom">
            <div>
                <DeliveryIcon className={classes.icons} />
            </div>
        </Tooltip>
    );
};

const InvoiceAddress = () => {
    const classes = useStyles();

    return (
        <Tooltip title={<FormattedMessage id="app.label.invoiceAddress" />} placement="bottom">
            <div>
                <InvoiceIcon className={classes.icons} />
            </div>
        </Tooltip>
    );
};

export const GetUsageTypeIcon = (props: GetUsageTypeIconProps) => {
    const { usageType } = props;
    const classes = useStyles();

    switch (usageType) {
        case UsageType.Invoice:
            return <InvoiceAddress />;

        case UsageType.Address:
            return <DeliveryAddress />;

        case UsageType.Both:
            return (
                <div className={classes.container}>
                    <InvoiceAddress />
                    <Divider orientation="vertical" flexItem={true} className={classes.divider} />
                    <DeliveryAddress />
                </div>
            );

        default:
            return null;
    }
};
